export default {
      id: "graph-monteregie-usage",
      viewBox: "0 0 190 170",
      url: __webpack_public_path__ + "svg/sprite.svg#graph-monteregie",
      toString: function () {
        return this.url;
      }
    }